export const TAX_LIST_PAGE_RECEIVE = "TAX_LIST_PAGE_RECEIVE";
export const TAX_LIST_PAGE_ERROR = 'TAX_LIST_PAGE_ERROR';
export const TAX_ITEM_DATA = 'TAX_ITEM_DATA';